const Terms = () => {
  return (
    <div id="terms" className="page">
      <h1>Terms and Conditions</h1>
      
      <p>
        Welcome! Please read these Terms and Conditions carefully before using our application.
        By accessing or using the service, you agree to be bound by these terms.
      </p>

      <section>
        <h2>1. Use of the Service</h2>
        <p>
          You may use this application for personal, non-commercial purposes in accordance with these terms.
          You agree not to misuse the application or attempt to access unauthorized features.
        </p>
      </section>

      <section>
        <h2>2. Data and Privacy</h2>
        <p>
          Currently, this application does not store any personal user data or require accounts.  
          In the future, we may introduce features that use or store user data. If and when this happens,
          updated Terms and a Privacy Policy will be provided, and your continued use of the service
          will constitute acceptance.
        </p>
      </section>

      <section>
        <h2>3. Intellectual Property</h2>
        <p>
          All content provided by the application is protected by copyright and other intellectual
          property laws. You may not reproduce, distribute, or modify content without permission.
        </p>
      </section>

      <section>
        <h2>4. Limitation of Liability</h2>
        <p>
          The application is provided "as is." We are not responsible for any direct or indirect
          damages arising from your use of the service.
        </p>
      </section>

      <section>
        <h2>5. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of the service constitutes
          acceptance of the updated Terms.
        </p>
      </section>

      <section>
        <h2>6. Contact Information</h2>
        <p>
        If you have questions about these Terms, please contact us using the&nbsp;
        <a href="/support">support page</a>.
        </p>
      </section>
    </div>
  );
};

export default Terms;
